import styled from 'styled-components';
import { Colors } from '../../../theme';
import { breakpointLG } from '../styles/breakpoints';
export const Wrapper = styled.div `
  position: absolute;
  top: 64px;
  left: 0;
  z-index: 10;
  box-sizing: border-box;
  display: ${(props) => (props.$open === true ? 'flex' : 'none')};
  flex-direction: column;
  width: 100vw;
  height: calc(100vh - 64px);
  overflow-y: auto;
  background-color: ${Colors.white};

  @media (min-width: ${breakpointLG}) {
    display: none;
  }
`;
//# sourceMappingURL=styles.js.map